
import { useState, useEffect } from "react";
import { Shield, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";

interface MonitoringStatusProps {
  isActive: boolean;
  warningCount: number;
}

export function MonitoringStatus({ isActive, warningCount }: MonitoringStatusProps) {
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (warningCount > 0) {
      setShowAlert(true);
      const timer = setTimeout(() => setShowAlert(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [warningCount]);

  return (
    <div className="fixed bottom-4 right-4 space-y-2">
      <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm p-2 rounded-sm shadow-lg border border-border">
        <Shield className={isActive ? "text-green-500" : "text-muted-foreground"} size={16} />
        <span className="text-sm">
          Monitoring {isActive ? (
            <Badge variant="outline" className="ml-1 bg-green-500/10 text-green-500">
              Active
            </Badge>
          ) : (
            <Badge variant="outline" className="ml-1 bg-yellow-500/10 text-yellow-500">
              Inactive
            </Badge>
          )}
        </span>
      </div>

      {showAlert && (
        <Alert className="bg-card/80 backdrop-blur-sm border-yellow-500/50">
          <AlertTriangle className="h-4 w-4 text-yellow-500" />
          <AlertDescription className="text-sm">
            Suspicious activity detected. Please ensure you're following test guidelines.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
